"use client";

import type { FC, Ref } from "react";
import { Message } from "@huub-web/ui/components/Message";
import type { TemplateCollection } from "../../types";
import { TemplatesParser } from "../../components";

export type MessageTemplateProps = {
  /**
   * The variant of the message
   */
  variant?: "default" | "success" | "error" | "warning";
  /**
   * The body content of the message (supports Markdown)
   */
  body?: string;
  /**
   * The templates to render inside the message
   */
  templates?: TemplateCollection;
  /**
   * Forwarded ref to the root element
   */
  ref?: Ref<HTMLDivElement>;
};

export const MessageTemplate: FC<MessageTemplateProps> = ({
  variant = "default",
  body,
  templates,
  ref,
}) => (
  <Message ref={ref} variant={variant} body={body}>
    {templates && templates.length > 0 && (
      <TemplatesParser templates={templates} level={1} />
    )}
  </Message>
);
